import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  fieldLabel: {
    paddingBottom: `0 !important`,
    paddingTop: `0 !important`,
    width: '100%',
  },
  fieldControl: {
    paddingTop: '0 !important',
    width: '100%',
  },
}));

interface FormLabelAndInputProps {
  label: string;
  children: React.ReactNode;
}

const FormLabelAndInput = (props: FormLabelAndInputProps) => {
  const { label, children } = props;
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.fieldLabel}>
        <Typography variant='subtitle2' component='label'>
          {label}
        </Typography>
      </div>
      <div className={classes.fieldControl}>{children}</div>
    </React.Fragment>
  );
};

export default FormLabelAndInput;
